import { useState } from 'react';

interface Props {
  name: string;
  avatarUrl?: string | null;
  size?: number;
  className?: string;
}

const COLORS = [
  'bg-teal-100 text-teal-700 dark:bg-teal-900/50 dark:text-teal-300',
  'bg-violet-100 text-violet-700 dark:bg-violet-900/50 dark:text-violet-300',
  'bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-300',
  'bg-sky-100 text-sky-700 dark:bg-sky-900/50 dark:text-sky-300',
  'bg-rose-100 text-rose-700 dark:bg-rose-900/50 dark:text-rose-300',
  'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300',
];

function colorFor(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return COLORS[Math.abs(hash) % COLORS.length];
}

export function UserAvatar({ name, avatarUrl, size = 36, className = '' }: Props) {
  const [imgError, setImgError] = useState(false);
  const initial = (name?.[0] ?? '?').toUpperCase();
  const sizeStyle = { width: size, height: size, fontSize: size * 0.42 };

  if (avatarUrl && !imgError) {
    return (
      <img
        src={avatarUrl}
        alt={name}
        style={sizeStyle}
        className={`rounded-full object-cover shrink-0 ${className}`}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div
      style={sizeStyle}
      className={`rounded-full shrink-0 flex items-center justify-center font-bold ${colorFor(name)} ${className}`}
    >
      {initial}
    </div>
  );
}
